import gql from 'graphql-tag';
export default gql`
mutation ($args: FA_TemporaryOfferInputs!){
    fakturaAssist{
    	createFA_TemporaryOffer(args: $args){
	    	id
	 	}
 	}
}`;
